import React from 'react';

import OpcoesBuscaPopover from '../../../util/opcoesBuscaPopover/.mixins';
import ChildrenOpcoesBusca from '../childrens/contentFiltroBusca/.mixins';

import OpcoesBuscaTags from '../../opcoesBuscaTags/.mixins';

export default (props) => {
  return (
    <>
      <OpcoesBuscaPopover
        Children={() => {
          return (
            <ChildrenOpcoesBusca {...props} />
          )
        }}
        handlerCleanFilters={props.handlerCleanFilters}
        handlerAplicarFilters={props.handlerAplicarFilters}
        anchororigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformorigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        popoverWidth={"40%"}
        popoverPadding={"2%"}
        btvariant={"text"}
        btLabel={props.btLabel}
      />
      {props.colunasFilterTags != null &&
        <OpcoesBuscaTags {...props} />
      }
    </>
  );
};
